export function getQuickfactContentHeight(quickfact) {
  const content = quickfact.shadowRoot.querySelector('[part~="content"]');

  // store original styles
  const originalStyles = {
    visibility: content.style.getPropertyValue('visibility'),
    display: content.style.getPropertyValue('display'),
    position: content.style.getPropertyValue('position'),
    height: content.style.getPropertyValue('height'),
  };

  content.style.setProperty('visibility', 'hidden');
  content.style.setProperty('display', 'block');
  content.style.setProperty('position', 'absolute');
  content.style.setProperty('height', 'auto');

  const height = content.clientHeight;

  // restore original styles
  content.style.setProperty('visibility', originalStyles.visibility);
  content.style.setProperty('display', originalStyles.display);
  content.style.setProperty('position', originalStyles.position);
  content.style.setProperty('height', originalStyles.height);

  return height;
}

export function getPositions(element: HTMLElement, querySelectorName: string) {
  const grid = element.querySelector(querySelectorName);
  const gridComputedStyle = window.getComputedStyle(grid);

  const numberOfRows = gridComputedStyle.getPropertyValue('grid-template-rows').split(' ').length;

  const numberOfColumns = gridComputedStyle.getPropertyValue('grid-template-columns').split(' ').length;
  const positions = [];

  for (let row = 1; row <= numberOfRows; row += 1) {
    for (let col = 1; col <= numberOfColumns; col += 1) {
      positions.push({ row, column: col });
    }
  }
  return { numberOfRows, numberOfColumns, positions };
}
